var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m124.572 460.62v9.807c0 1.137.068 2.278.259 3.398 1.103 6.471 4.906 11.674 10.01 14.734 8.118 4.865 14.91 11.655 19.16 20.111 1.026 2.042 3.116 3.331 5.401 3.331h193.194c2.285 0 4.375-1.289 5.401-3.331 4.25-8.457 11.043-15.245 19.161-20.111 5.103-3.059 8.904-8.26 10.009-14.729.192-1.122.26-2.264.26-3.402v-9.807l-112.702-23.272z",
    fill: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.257 460.62c-1.813 3.054-4.339 5.556-7.305 7.335-8.117 4.866-14.911 11.655-19.16 20.111-1.026 2.042-3.116 3.331-5.401 3.331h-172.268c6.218 4.547 11.4 10.351 14.879 17.273 1.026 2.042 3.116 3.331 5.401 3.331h193.194c2.285 0 4.375-1.289 5.401-3.331 4.25-8.456 11.043-15.245 19.16-20.111 5.103-3.059 8.904-8.26 10.009-14.729.192-1.122.26-2.264.26-3.402v-9.807l-26.749-12.8z",
    fill: "#afaab4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.269 3.815c-13.602-7.853-30.995-3.193-38.849 10.409l-30.17 52.257h65.678l13.751-23.818c7.853-13.602 3.192-30.995-10.41-38.848zm-6.669 27.005-7.148 12.38c-1.431 2.479-4.028 3.864-6.698 3.864-1.311 0-2.639-.334-3.856-1.036-3.695-2.134-4.962-6.859-2.828-10.554l7.148-12.38c2.133-3.697 6.86-4.962 10.554-2.828 3.695 2.133 4.961 6.859 2.828 10.554z",
    fill: "#afaab4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.56 18.146c-.519 1.33-1.145 2.639-1.881 3.913l-9.003 15.594c-2.938 5.089-8.368 8.224-14.245 8.224h-3.556c-1.234.775-2.667 1.187-4.121 1.187-1.311 0-2.639-.334-3.856-1.036-.084-.049-.167-.099-.248-.15h-32.504l-18.267 31.64 72.049-11.036 13.751-23.818c4.482-7.764 4.888-16.763 1.881-24.518z",
    fill: "#a298a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.793 131.973c-9.613-8.544-15.112-20.792-15.112-33.653l-126.387-9.149-90.974 9.149c0 12.861-5.5 25.108-15.112 33.653-4.856 4.317-7.635 10.504-7.635 17.001v276.763l40.7 34.882h222.155v-222.154l-14.678-18.691 14.678-56.892v-13.908c-.001-6.497-2.779-12.684-7.635-17.001z",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.31,
    cy: 236.516,
    fill: "#ffc250",
    r: 43.983
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.793 131.973c-9.612-8.545-15.112-20.791-15.112-33.653l-23.2-9.149-13.017 9.149c2.513 4.884 5.925 9.319 10.121 13.049 4.856 4.317 7.635 10.504 7.635 17.002v321.452c0 1.138-.068 2.28-.26 3.402-.462 2.709-1.398 5.195-2.703 7.395h44.171v-222.155l-11.042-24.072 11.042-51.51v-13.908c-.001-6.498-2.779-12.685-7.635-17.002z",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.428 162.882-262.855 262.856v34.882h40.699l222.156-222.155z",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.427 238.465v-75.582l-41.207 41.207v75.582z",
    fill: "#dfdde2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.074 153.704h-200.148c-4.268 0-7.726-3.459-7.726-7.726 0-4.268 3.459-7.726 7.726-7.726h200.149c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.727 7.726z",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.074 153.704c4.268 0 7.726-3.459 7.726-7.726 0-4.268-3.459-7.726-7.726-7.726h-9.854v15.453h9.854z",
    fill: "#d82e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.998 98.32h-225.996c-6.689 0-12.111-5.422-12.111-12.111v-7.617c0-6.689 5.422-12.111 12.111-12.111h225.996c6.689 0 12.111 5.422 12.111 12.111v7.617c0 6.689-5.422 12.111-12.111 12.111z",
    fill: "#c6c1c8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftDrink);
export default __webpack_public_path__ + "static/media/soft-drink.2be0929247dae3a56de884aea6c32185.svg";
export { ForwardRef as ReactComponent };